// To test: Google Tag Manager should recognize honorhealth.ddev.site domains and add the chat feature.
// If it does not, this is the script that can be added manually to the bottom of `docroot/themes/custom/honorhealth/templates/layout/page.html.twig`
// `<script src="https://guide.loyalhealth.com/client/client.bundle.js" type="text/javascript" data-id="guide-client-id" data-value="47982caf-3f77-4395-af75-21f47c8e9351" async></script>`

((Drupal) => {
  'use strict';

  Drupal.behaviors.HonorHealthLoyalChatCustomButtons = {
    attach: function () {

      let loyalChatCustomButtons = document.querySelectorAll('.loyal-custom-button');

      Array.from(loyalChatCustomButtons).forEach((button) => {
        button.addEventListener('click', (event) => {
          // This can be a `button` or `a` tag. `a` link needs to be blocked.
          event.preventDefault();

          window.GuideSDK.bot.purgeConversation();

          window.GuideSDK.bot.openWindow();

          // These buttons can be used in blocks or in WYSIWYG as needed.

          // Example button to start a message:
          // `<button class="loyal-custom-button" data-message="covid 19">Covid 19</button>`
          if (button.hasAttribute('data-message')) {
            window.GuideSDK.bot.startConversation(button.getAttribute('data-message'));
          }

          // Example button to start directly with agent:
          // `<button class="loyal-custom-button" data-chat-with-agent="true">Chat with an agent</button>`
          if (button.hasAttribute('data-chat-with-agent') && button.getAttribute('data-chat-with-agent') === 'true') {
            // This skips the intro and goes right to chat with an agent.
            window.GuideSDK.bot.startConversation('Chat with an agent');
          }
        });
      });
    }
  };
})(Drupal);
